import { useTranslation } from "react-i18next";

import {
  HeaderContainer,
  Title,
  Subtitle,
} from "../../MeasurementModal.styles";
import { SpirometryListTitle } from "../BlowAcceptabilitySection/BlowAcceptabilitySection.styles";
import { OptionsPopover } from "../OptionsPopover";
import { SpirometryValuesSection } from "../SpirometryValuesSection";
import {
  SpirometryContainer,
  ContentContainer,
  ChartContainer,
  ArtiQContainer,
  SubtitleGradeContainer,
} from "./SpirometrySection.styles";
import { SpirometrySectionChart } from "./SpirometrySectionChart";

type SessionDetailsEmptyStateProps = {
  isPinnedGraph?: boolean;
  measurementChartWidth: number;
  isPinned?: boolean;
  onPinnedChange?: (isPinned: boolean) => void;
};

export function SessionDetailsEmptyState({
  isPinnedGraph,
  measurementChartWidth,
  isPinned,
  onPinnedChange,
}: SessionDetailsEmptyStateProps) {
  const { t } = useTranslation();

  return (
    <SpirometryContainer isPinnedGraph={isPinnedGraph}>
      {/* Same single "..." menu as the loaded session, but the export action
          is hidden until a session's details are open. */}
      <OptionsPopover
        isPinned={isPinned}
        onPinnedChange={onPinnedChange}
        showExport={false}
      />

      <HeaderContainer css={{ marginLeft: 0, marginBottom: 38 }}>
        <Title>{t("patientPage_measurementModal_sessionDetails")}</Title>
        <SubtitleGradeContainer>
          <Subtitle css={{ marginTop: 0, marginBottom: 0 }}>
            {t("patientPage_measurementModal_selectDataPoint")}
          </Subtitle>
        </SubtitleGradeContainer>
      </HeaderContainer>

      <ContentContainer isPinnedGraph={isPinnedGraph}>
        <ChartContainer css={{ width: measurementChartWidth }}>
          <SpirometrySectionChart
            xConfig={{
              dataKey: "x",
              type: "number",
              minTickGap: 2,
              allowDecimals: false,
              label: {
                value: "Vol (L)",
                fontSize: "12px",
                position: "insideBottomLeft",
              },
              domain: [0, 8],
              tickFormatter(value) {
                return Number.parseFloat(value).toFixed(1);
              },
            }}
            yConfig={{
              axisSize: 42,
              label: {
                value: "Flow (L/s)",
                angle: -90,
                fontSize: "12px",
                position: "insideLeft",
              },
              domain: [0, 12],
            }}
            chartConfig={[
              {
                yKey: "y",
                dot: false,
                color: "#7562A8",
                lineType: "monotone",
              },
            ]}
            width="100%"
            height={207}
            data={[]}
            linesToShow={[]}
          />

          <SpirometrySectionChart
            xConfig={{
              dataKey: "x",
              type: "number",
              minTickGap: 2,
              allowDecimals: false,
              label: {
                value: "Time (s)",
                fontSize: "12px",
                position: "insideBottomLeft",
              },
              domain: [0, 8],
              tickFormatter(value) {
                return Number.parseFloat(value).toFixed(1);
              },
            }}
            yConfig={{
              axisSize: 42,
              label: {
                value: "Vol (L)",
                angle: -90,
                fontSize: "12px",
                position: "insideLeft",
              },
              domain: [0, 12],
            }}
            chartConfig={[
              {
                yKey: "y",
                dot: false,
                color: "#7562A8",
                lineType: "monotone",
              },
            ]}
            width="100%"
            height={207}
            data={[]}
            linesToShow={[]}
          />
        </ChartContainer>

        <ArtiQContainer>
          <SpirometryValuesSection
            spirometryTests={[]}
            archivedSpirometryTestsIds={[]}
          />
          <div
            style={{
              position: "relative",
              columnGap: "1px",
              marginTop: "60px",
            }}
          >
            <SpirometryListTitle>
              <p>{t("patientPage_measurementModal_blow_accept")}</p>
            </SpirometryListTitle>
          </div>
        </ArtiQContainer>
      </ContentContainer>
    </SpirometryContainer>
  );
}
